import AboutUs from '@/pages/AboutUs/AboutUs';
import ContactUs from '@/pages/ContactUs/ContactUs';
import Layout from '@/pages/layout';
import Main from '@/pages/main';
import NotFound from '@/pages/NotFound';
import ProductDetail from '@/pages/product-detail';
import Products from '@/pages/products';
import { RouteObject } from 'react-router-dom';

export default [
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        path: '/',
        element: <Main />,
      },
      {
        path: '/hakkimizda',
        element: <AboutUs />,
      },
      {
        path: '/urunler',
        element: <Products />,
      },
      {
        path: '/urunler/:catslug',
        element: <Products />,
      },
      {
        path: '/urunler/:catslug/:productslug',
        element: <ProductDetail />,
      },
      {
        path: "/iletisim",
        element: <ContactUs />,
      }
    ],
  },

  {
    path: '/*',
    element: <NotFound />,
  }
] as RouteObject[];
